var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0572 5.72383C11.5779 5.20314 12.4221 5.20314 12.9428 5.72383L22.2762 15.0572C22.7968 15.5778 22.7968 16.4221 22.2762 16.9428L12.9428 26.2761C12.4221 26.7968 11.5779 26.7968 11.0572 26.2761C10.5365 25.7554 10.5365 24.9112 11.0572 24.3905L19.4478 16L11.0572 7.60946C10.5365 7.08875 10.5365 6.24454 11.0572 5.72383Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoIcon);
export default __webpack_public_path__ + "static/media/goto-icon.249fb3bd82deac7a3f200642f84620f8.svg";
export { ForwardRef as ReactComponent };